import axios from "axios";
import { BASE_URL } from "./apiConfig";

const apiClient = axios.create({
  baseURL: BASE_URL,
});

apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("accessToken");

    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
      //console.log("🔐 Sending request with token:", token.slice(0, 30) + "...");
    } else {
      console.warn("⚠️ No access token found in localStorage");
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export default apiClient;
